import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import * as RB from "react-bootstrap";
import DatePicker from "react-datepicker";
import * as utils from "../../Utils/comman";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import Multiselect from "multiselect-react-dropdown";
import {
  AddCardOutlined,
  AddCircle,
  AddCircleOutline,
  Delete,
  DeleteOutline,
} from "@mui/icons-material";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // import styles for the editor
import Select from "react-select";

function Add(props) {
  const [isEdit, setisEdit] = useState(false);
  const [isValidImage, setisValidImage] = useState(false);
  const [cityError, setcityError] = useState("");
  const [districtError, setDistrictError] = useState("");
  const [stateError, setStateError] = useState("");
  const [cities, setCities] = useState([]);
  const [isSalesValid, setIsSalesValid] = useState(true);
  const [districts, setDistricts] = useState([]);
  const [states, setStates] = useState([]);
  const [salesData, setSalesData] = useState([]);
  const [logisticsData, setLogisticsData] = useState([]);
  const [isLogisticValid, setIsLogisticValid] = useState(true);
  const multiselectRef = useRef(null);
  const dispatch = useDispatch();
  const [isDraggingOver, setIsDraggingOver] = useState(false);

  let vendorType = "";
  if (props.currentComp === "distributor") vendorType = "Distributor";
  else if (props.currentComp === "dealer") vendorType = "Dealer";
  else if (props.currentComp === "retailer") vendorType = "Retailer";
  else if (props.currentComp === "key-accounts") vendorType = "Key Accounts";
  else if (props.currentComp === "pro") vendorType = "PRO";
  const [formData, setFormData] = useState({
    name: "",
    address: "",
    city: "",
    state: "",
    district: "",
    pinCode: "",
    gstUni: "",
    invoiceCode: "",
    contactName: "",
    email: "",
    mobileNo: "",
    storeManager: [],
    logisticManager: [],
    user_name: "",
    password: "",
  });

  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);

  const userProfile = useSelector((state) => state?.userProfile?.userProfile);

  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let validatedValue = value;

    if (name === "mobileNo") {
      validatedValue = value.replace(/\D/g, "");
    }

    if (name === "state") {
      getDistrictList(validatedValue);
      // console.log("Am here changing");
      setFormData({
        ...formData,
        state: validatedValue,
        district: "",
        city: "",
      });
      return;
    }

    if (name === "district") {
      getCitiesList(validatedValue);
      setFormData({
        ...formData,
        district: validatedValue,
        city: "",
      });
      return;
    }

    setFormData({
      ...formData,
      [name]: validatedValue,
    });
  };

  const handleBackClick = () => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const validateSales = () => {
    if (formData.storeManager.length === 0) {
      setIsSalesValid(false);
      return false;
    }
    setIsSalesValid(true);
    return true;
  };

  const validateLogistic = () => {
    if (formData.logisticManager.length === 0) {
      setIsLogisticValid(false);
      return false;
    }
    setIsLogisticValid(true);
    return true;
  };

  const handleSubmit = (e) => {
    const isSalesValid = validateSales();
    const isLogisticValid = validateLogistic();
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false || !isSalesValid || !isLogisticValid) {
      e.stopPropagation();
      setValidated(true);
    } else {
      setIsSubmit(true);
    }
  };

  useEffect(() => {
    if (isSubmit) {
      var bodyFormData = new FormData();
      if (isEdit) {
        bodyFormData.append("id", props?.rowData?.id);
        bodyFormData.append("client_id", userProfile?.employeeId);
      }
      bodyFormData.append("name", formData.name);
      bodyFormData.append("address", formData.address);
      bodyFormData.append("state", formData.state);
      bodyFormData.append("city", formData.city);
      bodyFormData.append("district", formData.district);
      bodyFormData.append("pincode", formData.pinCode);
      bodyFormData.append("invoice_code", formData.invoiceCode);
      bodyFormData.append("contact_person_name", formData.contactName);
      bodyFormData.append("contact_person_email", formData.email);
      bodyFormData.append("contact_person_phone", formData.mobileNo);
      bodyFormData.append("user_name", formData.user_name);
      bodyFormData.append("password", formData.password);
      // bodyFormData.append("sales_co_ordinator", formData.storeManager);

      formData.storeManager.forEach((sales, index) => {
        bodyFormData.append(`sales_co_ordinator[${index}]`, sales);
      });
      formData.logisticManager.forEach((logistic, index) => {
        bodyFormData.append(`logistic_department[${index}]`, logistic);
      });
      bodyFormData.append("gst_uni", formData.gstUni);
      utils
        .callAPI("post", "/sales/save_location", bodyFormData)
        .then((res) => {
          if (typeof res !== "undefined") {
            setIsSubmit(false);
            setisEdit(false);
            const propdata = {
              mode: "list",
            };
            props.onChange(propdata);
          } else {
            setIsSubmit(false);
          }
        })
        .catch((err) => {
          setIsSubmit(false);
        });
    }
  }, [isSubmit]);

  useEffect(() => {
    if (props.rowData && Object.keys(props.rowData).length > 0) {
      const salesArray = props?.rowData?.sales_co_ordinator?.split(",");
      const logisticArray = props?.rowData?.logistic_department?.split(",");
      // console.log("yeh hai sales array", logisticArray );
      setisEdit(true);
      if (props?.rowData?.state) {
        getDistrictList(props?.rowData?.state);
      }
      if (props?.rowData?.district) {
        getCitiesList(props?.rowData?.district);
      }
      setFormData({
        name: props?.rowData?.name || "",
        address: props?.rowData?.address || "",
        city: props?.rowData?.city || "",
        state: props?.rowData?.state || "",
        district: props?.rowData?.district || "",
        pinCode: props?.rowData?.pincode || "",
        gstUni: props?.rowData?.gst_uni || "",
        invoiceCode: props?.rowData?.invoice_code || "",
        contactName: props?.rowData?.contact_person_name || "",
        email: props?.rowData?.contact_person_email || "",
        mobileNo: props?.rowData?.contact_person_phone || "",
        storeManager: salesArray || "",
        logisticManager: logisticArray || "",
        user_name: props?.rowData?.user_name || "",
        password: props?.rowData?.password || "",
      });
    } else {
      setisEdit(false);
    }
  }, [props.rowData]);

  const getStatesList = () => {
    utils
      .callAPI("get", `/sales/getStateList`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setStates(res);
        } else {
          setStates([]);
        }
      })
      .catch((err) => {
        setStates([]);
      });
  };

  const getSalesCoList = () => {
    utils
      .callAPI("get", `/sales/getSales_co_ordinator_lists`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setSalesData(res);
        } else {
          setSalesData([]);
        }
      })
      .catch((err) => {
        setSalesData([]);
      });
  };

  const getLogisticManagersList = () => {
    utils
      .callAPI("get", `/sales/getLogistic_department_lists`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setLogisticsData(res);
        } else {
          setLogisticsData([]);
        }
      })
      .catch((err) => {
        setLogisticsData([]);
      });
  };

  const getDistrictList = (state) => {
    utils
      .callAPI("get", `/sales/getDistrictList?state=${state}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setDistricts(res);
        } else {
          setDistricts([]);
        }
      })
      .catch((err) => {
        setDistricts([]);
      });
  };

  const getCitiesList = (district) => {
    utils
      .callAPI("get", `/sales/getCityList?district=${district}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setCities(res);
        } else {
          setCities([]);
        }
      })
      .catch((err) => {
        setCities([]);
      });
  };

  useEffect(() => {
    getStatesList();
    getSalesCoList();
    getLogisticManagersList();
  }, []);

  const handleSelect = (selectedList, selectedItem) => {
    const name = "state";
    const value =
      selectedList.length > 0 ? selectedList[0].cat : formData.state; // Get the ID of the selected item

    setFormData({
      ...formData,
      [name]: value,
    });
    setStateError(selectedList?.length > 0);
    if (multiselectRef.current) {
      multiselectRef.current.select.setValue(value); // Set value again
    }
  };

  const handleRemove = (selectedList, removedItem) => {
    const removedId = String(removedItem.cat);

    // Don't update formData.state if there's still a selection
    if (selectedList.length > 0) {
      return; // Early return to avoid unnecessary state update
    }

    // Update formData.state to an empty string if no selection left
    setFormData({
      ...formData,
      state: "",
    });
    setStateError(selectedList?.length > 0);
  };

  const handleSalesMultiSelect = (selectedList, selectedItem) => {
    const salesIds = selectedList.map((item) => item.cat);
    setFormData({
      ...formData,
      storeManager: salesIds,
    });
    // console.log("this is coming", selectedList?.length > 0);
    setIsSalesValid(selectedList?.length > 0);
  };

  const handleLogisticMultiSelect = (selectedList, selectedItem) => {
    const logisticIds = selectedList.map((item) => item.cat);
    setFormData({
      ...formData,
      logisticManager: logisticIds,
    });
    // console.log("this is coming", selectedList?.length > 0);
    setIsLogisticValid(selectedList?.length > 0);
  };

  const handleSalesRemove = (selectedList, removedItem) => {
    const removedId = String(removedItem.cat);
    const updatedZones = formData.storeManager.filter((id) => id !== removedId);

    setFormData({
      ...formData,
      storeManager: updatedZones,
    });
    setIsSalesValid(selectedList?.length > 0);
  };

  const handleLogisticRemove = (selectedList, removedItem) => {
    const removedId = String(removedItem.cat);
    const updatedZones = formData.logisticManager.filter(
      (id) => id !== removedId
    );

    setFormData({
      ...formData,
      logisticManager: updatedZones,
    });
    setIsLogisticValid(selectedList?.length > 0);
  };

  const stateOptions =
    states?.map((state) => ({ value: state, label: state })) || [];
  const districtOptions =
    districts?.map((district) => ({ value: district, label: district })) || [];
  const cityOptions =
    cities?.map((city) => ({ value: city, label: city })) || [];

  return (
    <div className="section-body ">
      <RB.Card className="">
        <RB.Card.Header>
          {/* <h4>{isEdit ? `Edit ${vendorType}` : `Add ${vendorType}`}</h4> */}
          <h4>{isEdit ? `Edit ` : `Add `}</h4>
          <div className="card-header-action">
            <RB.Button
              className="btn btn-primary me-2"
              onClick={handleBackClick}
            >
              Back
            </RB.Button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body>
          <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
            <h6></h6>
            <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Name"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                      maxLength={32}
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="GST/UNI"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter GST/UNI"
                      name="gstUni"
                      value={formData.gstUni}
                      onChange={handleInputChange}
                      maxLength={32}
                      // required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Invoice Code"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Invoice Code"
                      name="invoiceCode"
                      value={formData.invoiceCode}
                      onChange={handleInputChange}
                      maxLength={32}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6} className="no-validation-icon">
                <div
                  className={
                    formData.channelName === "" ? "mb-3 mt-4" : "mb-3 mt-3"
                  }
                >
                  <RB.FloatingLabel
                    //label="Sales Coordinator Name"
                    className="floating-label-fancy"
                  >
                    <Multiselect
                      displayValue="key"
                      onKeyPressFn={function noRefCheck() {}}
                      onRemove={handleSalesRemove}
                      onSearch={function noRefCheck() {}}
                      //onSelect={function noRefCheck() {}}
                      onSelect={handleSalesMultiSelect}
                      name="storeManager"
                      value={formData?.storeManager}
                      onChange={handleInputChange}
                      // closeOnSelect={formData.channelName !== ""}
                      required
                      options={
                        Array.isArray(salesData)
                          ? salesData.map((name) => ({
                              cat: name.id,
                              key: `${name.firstName} ${name.lastName}`,
                            }))
                          : []
                      }
                      selectedValues={
                        Array.isArray(salesData)
                          ? salesData
                              .filter((sales) =>
                                props?.rowData?.sales_co_ordinator?.includes(
                                  sales.id.toString()
                                )
                              )
                              .map((sales) => ({
                                cat: sales.id,
                                key: `${sales.firstName} ${sales.lastName}`,
                              }))
                          : []
                      }
                      placeholder="Store Manager..."
                      customCloseIcon={
                        <>
                          <i className="material-icons-outlined md14 ms-1">
                            cancel
                          </i>
                        </>
                      }
                      style={{
                        chips: {
                          background: "#FFDE1B",
                          color: "#000000",
                          borderRadius: "1rem",
                          cursor: "pointer",
                        },
                        multiselectContainer: {
                          zIndex: 10,
                        },
                        searchBox: {
                          border: "none",
                          borderBottom: "1px solid #dee2e6",
                          borderRadius: "0px",
                        },
                      }}
                      // placeholder="Select Channel Partner Name..."
                    />
                    {!isSalesValid && (
                      <div className="text-danger mt-1">
                        Please select at least one Store Manager.
                      </div>
                    )}
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6} className="no-validation-icon">
                <div
                  className={
                    formData.channelName === "" ? "mb-3 mt-4" : "mb-3 mt-3"
                  }
                >
                  <RB.FloatingLabel
                    //label="Sales Coordinator Name"
                    className="floating-label-fancy"
                  >
                    <Multiselect
                      displayValue="key"
                      onKeyPressFn={function noRefCheck() {}}
                      onRemove={handleLogisticRemove}
                      onSearch={function noRefCheck() {}}
                      //onSelect={function noRefCheck() {}}
                      onSelect={handleLogisticMultiSelect}
                      name="logisticManager"
                      value={formData?.logisticManager}
                      onChange={handleInputChange}
                      // closeOnSelect={formData.channelName !== ""}
                      required
                      options={(Array.isArray(logisticsData)
                        ? logisticsData
                        : []
                      ).map((name) => ({
                        cat: name.id,
                        key: `${name.firstName} ${name.lastName}`,
                      }))}
                      selectedValues={(Array.isArray(logisticsData)
                        ? logisticsData
                        : []
                      )
                        .filter((logistics) =>
                          props?.rowData?.logistic_department?.includes(
                            logistics.id.toString()
                          )
                        )
                        .map((logistics) => ({
                          cat: logistics.id,
                          key: `${logistics.firstName} ${logistics.lastName}`,
                        }))}
                      placeholder="Logisitic Manager..."
                      customCloseIcon={
                        <>
                          <i className="material-icons-outlined md14 ms-1">
                            cancel
                          </i>
                        </>
                      }
                      style={{
                        chips: {
                          background: "#FFDE1B",
                          color: "#000000",
                          borderRadius: "1rem",
                          cursor: "pointer",
                        },
                        multiselectContainer: {
                          zIndex: 10,
                        },
                        searchBox: {
                          border: "none",
                          borderBottom: "1px solid #dee2e6",
                          borderRadius: "0px",
                        },
                      }}
                      // placeholder="Select Channel Partner Name..."
                    />
                    {!isLogisticValid && (
                      <div className="text-danger mt-1">
                        Please select at least one Logistic Manager.
                      </div>
                    )}
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>

            <h6>Address Information</h6>
            <RB.Row>
              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Address"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      as="textarea"
                      type="text"
                      placeholder="Enter Address "
                      name="address"
                      value={formData.address}
                      onChange={handleInputChange}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mt-3">
                  <Select
                    name="state"
                    className="bom-productName-select"
                    options={stateOptions}
                    value={stateOptions.find(
                      (option) => option.value === formData.state
                    )}
                    onChange={(selectedOption) =>
                      handleInputChange({
                        target: {
                          name: "state",
                          value: selectedOption?.value || "",
                        },
                      })
                    }
                    placeholder="Select State..."
                    isSearchable
                  />
                  {stateError && (
                    <span className="text-danger">{stateError}</span>
                  )}
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mt-3">
                  <Select
                    name="district"
                    options={districtOptions}
                    className="bom-productName-select"
                    value={districtOptions.find(
                      (option) => option.value === formData.district
                    )}
                    onChange={(selectedOption) =>
                      handleInputChange({
                        target: {
                          name: "district",
                          value: selectedOption?.value || "",
                        },
                      })
                    }
                    placeholder="Select District..."
                    isSearchable
                  />
                  {districtError && (
                    <span className="text-danger">{districtError}</span>
                  )}
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mt-3">
                  <Select
                    name="city"
                    options={cityOptions}
                    value={cityOptions.find(
                      (option) => option.value === formData.city
                    )}
                    onChange={(selectedOption) =>
                      handleInputChange({
                        target: {
                          name: "city",
                          value: selectedOption?.value || "",
                        },
                      })
                    }
                    placeholder="Select City..."
                    isSearchable
                    className="bom-productName-select"
                  />
                  {cityError && (
                    <span className="text-danger">{cityError}</span>
                  )}
                </div>
              </RB.Col>

              <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Pin Code"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Pin Code "
                      name="pinCode"
                      value={formData.pinCode}
                      onChange={handleInputChange}
                      maxLength={6}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col>
            </RB.Row>

            <RB.Row>
              <h6>Contact Information</h6>
              <RB.Row>
                <RB.Col md={6}>
                  <div className="mb-3">
                    <RB.FloatingLabel
                      label="Contact Person Name"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        type="text"
                        placeholder="Enter Contact Person Name"
                        name="contactName"
                        value={formData.contactName}
                        onChange={handleInputChange}
                        required
                        maxLength={32}
                      />
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>

                <RB.Col md={6}>
                  <div className="mb-3">
                    <RB.FloatingLabel
                      label="Mobile No"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        type="text"
                        placeholder="Enter Mobile No"
                        name="mobileNo"
                        value={formData.mobileNo}
                        onChange={handleInputChange}
                        required
                        maxLength={10}
                      />
                      {/* {emergencyContactError ? (
                        <span className="text-danger">
                          {" "}
                          Please provide a valid Mobile Number.
                        </span>
                      ) : (
                        ""
                      )} */}
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>

                <RB.Col md={6}>
                  <div className="mb-3">
                    <RB.FloatingLabel
                      label="Email"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        type="email"
                        placeholder="Enter Email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                        maxLength={32}
                      />
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>
              </RB.Row>
            </RB.Row>

            <RB.Row>
              <h6>E-Invoice API Information</h6>
              <RB.Row>
                <RB.Col md={6}>
                  <div className="mb-3">
                    <RB.FloatingLabel
                      label="API User Name"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        type="text"
                        placeholder="Enter API User Name"
                        name="user_name"
                        value={formData.user_name}
                        onChange={handleInputChange}
                        required
                        maxLength={32}
                      />
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>

                <RB.Col md={6}>
                  <div className="mb-3">
                    <RB.FloatingLabel
                      label="API Password"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        type="password"
                        placeholder="Enter API Password"
                        name="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        required
                      />
                    </RB.FloatingLabel>
                  </div>
                </RB.Col>
              </RB.Row>
            </RB.Row>

            <RB.Row className="align-items-center mt-3">
              <RB.Col className="col-auto">
                <RB.Button variant="primary" type="submit">
                  Submit
                </RB.Button>
              </RB.Col>
            </RB.Row>
          </RB.Form>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default Add;
